<script>
import RadioLine from '@/components/molecules/input/RadioLine'

export default {
    name: 'MethodBlock',
    components: { RadioLine },
    props: {
        method: null,
        value: null,
        complementaryPayment: Boolean,
    },
    computed: {
        currency() {
            return this.$store.getters['active/currency']
        },
        cart() {
            return this.$cart
        },
        active() {
            return this.method === this.value && !this.cart.isGroupOrder
        },
    },
    methods: {
        onInput(val) {
            this.$emit('input', val)
        },
    },
}
</script>

<template lang="pug">
radio-line(:value="value" :class="{'card': !complementaryPayment, 'active': active && !complementaryPayment}" :reverse="complementaryPayment" @input="onInput" :data="method" :readonly="cart.loading")
    span {{ $t(`order.payment_methods.${method}`) }}


</template>
